<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import { BaseTableCell, BaseTableRow } from 'dashboard/components-next/table';
import { messageStamp } from 'shared/helpers/timeHelper';

defineProps({
  flow: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['open', 'delete', 'export']);

const statusClass = status =>
  status === 'published'
    ? 'bg-n-teal-2 text-n-teal-11'
    : 'bg-n-slate-4 text-n-slate-12';

const readableDateWithTime = date =>
  messageStamp(new Date(date), 'LLL d, yyyy hh:mm:ss a');
</script>

<template>
  <BaseTableRow :item="flow">
    <template #default>
      <BaseTableCell class="w-12 text-center rtl:pr-4 ltr:pl-4">
        <span class="text-body-main font-medium text-n-slate-12">
          {{ index }}
        </span>
      </BaseTableCell>

      <BaseTableCell class="w-[14rem] max-w-0">
        <div class="flex min-w-0 flex-col">
          <span class="truncate text-body-main font-medium text-n-slate-12">
            {{ flow.name }}
          </span>
          <span class="mt-1 truncate text-body-main text-n-slate-11">
            {{ flow.channel_type }}
          </span>
        </div>
      </BaseTableCell>

      <BaseTableCell class="w-24">
        <span
          class="inline-flex items-center rounded-md px-2 py-0.5 text-xs capitalize"
          :class="statusClass(flow.status)"
        >
          {{ flow.status }}
        </span>
      </BaseTableCell>

      <BaseTableCell class="w-14 text-center">
        <span
          class="inline-flex min-w-10 items-center justify-center whitespace-nowrap rounded-md bg-n-alpha-2 px-2 py-1 text-body-main text-n-slate-12"
        >
          {{ flow.inbox_id || '-' }}
        </span>
      </BaseTableCell>

      <BaseTableCell
        class="w-44"
        :title="readableDateWithTime(flow.updated_on)"
      >
        <span class="whitespace-nowrap text-body-main text-n-slate-12">
          {{ readableDateWithTime(flow.updated_on) }}
        </span>
      </BaseTableCell>

      <BaseTableCell align="end" class="w-28 ltr:pr-4 rtl:pl-4">
        <div class="flex justify-end gap-2">
          <Button
            v-tooltip.top="$t('CONVERSATION_FLOWS.ACTIONS.OPEN')"
            icon="i-lucide-pencil"
            slate
            sm
            :is-loading="loading"
            @click="$emit('open', flow.id)"
          />
          <Button
            v-tooltip.top="$t('CONVERSATION_FLOWS.ACTIONS.EXPORT_JSON')"
            icon="i-lucide-download"
            slate
            sm
            :is-loading="loading"
            @click="$emit('export', flow)"
          />
          <Button
            v-tooltip.top="$t('CONVERSATION_FLOWS.ACTIONS.DELETE')"
            icon="i-woot-bin"
            slate
            sm
            class="hover:enabled:bg-n-ruby-2 hover:enabled:text-n-ruby-11"
            :is-loading="loading"
            @click="$emit('delete', flow)"
          />
        </div>
      </BaseTableCell>
    </template>
  </BaseTableRow>
</template>
